import React from "react";
import DatePickerComponentV2 from "../../DatePickerComponentV2";

function GeneralInformationV2AdmissionSection(props) {
  const {
    translate,
    dateOfAdmission,
    handleDateOfAdmissionChange,
    dischargeDate,
    handleDischargeDateChange,
    projectedResidentialDischargeDate,
    handleProjectedResidentialDischargeDateChange,
    projectedProgramCompletionDate,
    handleProjectedProgramCompletionDateChange,
  } = props;

  return (
    <div style={{ paddingLeft: "0px", width: "100%", paddingBottom: "20px" }}>
      <div style={{ borderTop: "1px solid #cccccc", paddingTop: "20px", marginTop: "20px", gap: "10px" }}>
        <span id="admission-and-discharge" style={{ fontSize: "14px", fontWeight: "600", paddingLeft: "10px" }}>{translate("AdmissionAndDischarge")}</span>
      </div>
      <div style={{ width: "100%", paddingLeft: "10px", paddingTop: "15px", paddingBottom: "10px", display: "flex", flexDirection: "row", justifyContent: "space-between", flexWrap: "wrap" }}>
        <DatePickerComponentV2 title={translate("ActualAdmissionDate")} width="250px" value={dateOfAdmission} onChange={handleDateOfAdmissionChange} />
        <div style={{ paddingLeft: "0px" }}>
          <DatePickerComponentV2 title={translate("ActualDischargeDate")} width={250} value={dischargeDate} onChange={handleDischargeDateChange} />
        </div>
      </div>
      <div style={{ width: "100%", paddingLeft: "10px", paddingTop: "15px", paddingBottom: "10px", display: "flex", flexDirection: "row", justifyContent: "space-between", flexWrap: "wrap" }}>
        <DatePickerComponentV2 title={translate("ProjectedDischargeDate")} width={250} value={projectedResidentialDischargeDate} onChange={handleProjectedResidentialDischargeDateChange} />
        <div style={{ display: "flex", flexDirection: "column", marginLeft: 0 }}>
          <DatePickerComponentV2 title={translate("ProjAftercareCompletionDate")} width={250} value={projectedProgramCompletionDate} onChange={handleProjectedProgramCompletionDateChange} />
        </div>
      </div>
    </div>
  );
}

export default GeneralInformationV2AdmissionSection;
